/* eslint-disable */
//   df1321c4e1874227b18a70750e4bf9574f3a2781
// --
// This file has been generated by https://github.com/webrpc/webrpc using gen/typescript
// Do not edit by hand. Update your webrpc schema and re-generate.

import type { Collection } from "$lib/types/Collections";

// WebRPC description and code-gen version
export const WebRPCVersion = '';

// Schema version of your RIDL schema
export const WebRPCSchemaVersion = '';

// Schema hash generated from your RIDL schema
export const WebRPCSchemaHash = 'df1321c4e1874227b18a70750e4bf9574f3a2781';

//
// Types
//
export interface ActivateMemberStatus {
	email: string;
	memberAlreadyActive: boolean;
}

export interface dataSparq3Filter {
	id?: string;
	type: string;
	values?: Array<string>;
	accepted_values?: Array<string>;
}

export interface dataNewsletter {
	id: string;
	user_id?: string;
	hub_id: string;
	post_id: string;
	type: string;
	template_id: string;
	from_name: string;
	reply_to: string;
	subject: string;
	roles: Array<string>;
	mailing_list_ids: string[];
	recipient_count: number;
	frequency: string;
	skip_weekends?: boolean;
	created_at?: string;
	updated_at?: string;
	scheduled_at?: string;
	sent_at?: string;
	status: string;
	status_reason: string;
	sparq3_filter_ids?: Array<string>;
	sparq3_dynamic_filters?: Array<dataSparq3Filter>;
}

export interface presenterShortUser {
	id: string;
	username: string;
	name: string;
	avatar_url: string;
	email?: string;
	purged: boolean;
}

export interface presenterNewsletterMetric {
	delivered: number;
	clicked: number;
	bounced: number;
	rejected: number;
	marked_spam: number;
	unsubscribed: number;
}

export interface contentSource {
	hash?: string;
	network?: string;
	uid?: string;
	url?: string;
	published_at?: string;
	updated_at?: string;
	num_shares?: number;
	num_likes?: number;
}

export interface contentAuthor {
	uid?: string;
	username?: string;
	name?: string;
	profile_url?: string;
	avatar_url?: string;
	num_followers?: number;
	num_following?: number;
	num_posts?: number;
}

export interface contentImageCropper {
	x: number;
	y: number;
	zoom: number;
	rotation: number;
}

export interface contentOrigImage {
	file_id?: string;
	url: string;
	width: number;
	height: number;
	format?: string;
	cropper?: contentImageCropper;
}

export interface postgresqlJSONBConverter {}

export interface contentImage {
	url: string;
	width: number;
	height: number;
	format?: string;
	preload?: string;
	alt_text?: string;
	cloudinary: boolean;
	original?: contentOrigImage;
	etc?: { [key: string]: any };
}

export interface contentMedia {
	type: string;
	title?: string;
	description?: string;
	url: string;
	width: number;
	height: number;
	format?: string;
	thumbnail?: contentImage;
}

export interface contentOEmbedCode {
	url?: string;
	html?: string;
	width?: any;
	height?: any;
}

export interface contentPostWidget {
	url?: string;
	html?: string;
}

export interface AssetEtc {
	meta_title?: string;
	meta_description?: string;
	meta_author?: string;
	twitter_share_text?: string;
	linkedin_share_text?: string;
	facebook_share_text?: string;
	email_share_text?: string;
	link_url?: string;
	link_to_source?: boolean;
	widget?: contentPostWidget;
	moderator_id?: string;
	rejection_reason?: string;
	align?: string;
	block_type?: string;
	cover_image?: contentImage;
	cover_bg_color?: string;
	logo_image?: contentImage;
	title_size?: string;
	title_align?: string;
	title_color?: string;
	title_font?: string;
	body_align?: string;
	body_text_color?: string;
	footer_text_color?: string;
	footer_link_color?: string;
	body_bg_color?: string;
	display_powered_by_alida?: boolean;
	display_custom_footer_text?: boolean;
	custom_footer_text?: string;
}

export interface Asset {
	type: string;
	content_hints: Array<string>;
	source: contentSource;
	author: contentAuthor;
	title: string;
	description: string;
	body: string;
	context: string;
	title_image?: contentImage;
	tags: Array<string>;
	media: Array<contentMedia>;
	oembed?: contentOEmbedCode;
	child_assets?: Array<Asset>;
	etc: AssetEtc;
}

export interface PostEngagement {
	user_views?: number;
	anonymous_views?: number;
	user_shares?: number;
	anonymous_shares?: number;
	orgadmin_views?: number;
	orgadmin_shares?: number;
	like_count: number;
	comment_count: number;
}

export interface dataMetaTags {
	meta_title?: string;
	meta_description?: string;
	meta_canonical?: string;
}

export interface dataSentiment {
	value: string;
	positive?: number;
	negative?: number;
	neutral?: number;
	mixed?: number;
}

export interface Post {
	type: string;
	content_hints: Array<string>;
	source: contentSource;
	author: contentAuthor;
	title: string;
	description: string;
	body: string;
	context: string;
	title_image?: contentImage;
	tags: Array<string>;
	media: Array<contentMedia>;
	oembed?: contentOEmbedCode;
	child_assets?: Array<Asset>;
	etc: AssetEtc;
	id: string;
	root_id?: string;
	parent_id?: string;
	origin_id?: string;
	hash: string;
	seq?: number;
	hub_id: string;
	user_id?: string;
	collection_id?: string;
	status: string;
	file_id?: string;
	mime: string;
	file_path: string;
	view_count?: number;
	share_count?: number;
	engagement?: PostEngagement;
	created_at?: string;
	updated_at?: string;
	published_at?: string;
	children: Array<Post>;
	slug?: string;
	meta_title?: string;
	meta_description?: string;
	meta_canonical?: string;
	sentiment?: dataSentiment;
	hide_all: boolean;
}

export interface dataFooterLink {
	title: string;
	href: string;
}

export interface presenterShortHub {
	id: string;
	uid: string;
	name: string;
	hub_url: string;
	visibility: string;
	account_slug: string;
	locale: string;
	footer_links?: Array<dataFooterLink>;
}

export interface presenterShortCollection {
	id: string;
	name: string;
	tags: Array<string>;
	slug: string;
}

export interface PostEngagementUserSummary {
	unique: number;
	engagement: number;
	share: number;
}

export interface PostNetworkShares {
	email?: number;
	facebook?: number;
	twitter?: number;
	linkedin?: number;
	unknown?: number;
}

export interface PostEngagement {
	id?: string;
	status?: string;
	title?: string;
	published_at?: string;
	user?: presenterShortUser;
	collection?: presenterShortCollection;
	url?: string;
	users: PostEngagementUserSummary;
	total_views: number;
	total_shares: number;
	user_views?: number;
	anonymous_views?: number;
	user_shares?: number;
	anonymous_shares?: number;
	orgadmin_views?: number;
	orgadmin_shares?: number;
	like_count: number;
	comment_count: number;
	anonymous_network_shares: PostNetworkShares;
	network_shares: PostNetworkShares;
}

export interface presenterUserContext {
	liked: boolean;
	commented: boolean;
	viewed: boolean;
	shared: boolean;
}

export interface Post {
	type: string;
	content_hints: Array<string>;
	source: contentSource;
	author: contentAuthor;
	title: string;
	description: string;
	body: string;
	context: string;
	title_image?: contentImage;
	tags: Array<string>;
	media: Array<contentMedia>;
	oembed?: contentOEmbedCode;
	child_assets?: Array<Asset>;
	etc: AssetEtc;
	id: string;
	root_id?: string;
	parent_id?: string;
	origin_id?: string;
	hash: string;
	seq?: number;
	hub_id: string;
	user_id?: string;
	collection_id?: string;
	status: string;
	file_id?: string;
	mime: string;
	file_path: string;
	view_count?: number;
	share_count?: number;
	created_at?: string;
	updated_at?: string;
	published_at?: string;
	children: Array<Post>;
	slug?: string;
	meta_title?: string;
	meta_description?: string;
	meta_canonical?: string;
	sentiment?: dataSentiment;
	hide_all: boolean;
	hub?: presenterShortHub;
	user: presenterShortUser;
	collection?: presenterShortCollection;
	engagement?: PostEngagement;
	id_base62?: string;
	short_url?: string;
	user_context?: presenterUserContext;
	top_contributors?: Array<presenterShortUser>;
	url?: string;
	offset: number;
	views: number;
	like_count: number;
	comment_count: number;
	contribution_has_image?: boolean;
	user_role: string;
}

export interface presenterShortEmailTemplate {
	id?: string;
	name?: string;
}

export interface Newsletter {
	id: string;
	user_id?: string;
	hub_id: string;
	post_id: string;
	type: string;
	template_id: string;
	from_name: string;
	reply_to: string;
	subject: string;
	roles: Array<string>;
	mailing_list_ids: string[];
	recipient_count: number;
	frequency: string;
	skip_weekends?: boolean;
	created_at?: string;
	updated_at?: string;
	scheduled_at?: string;
	sent_at?: string;
	status: string;
	status_reason: string;
	sparq3_filter_ids?: Array<string>;
	sparq3_dynamic_filters?: Array<dataSparq3Filter>;
	user?: presenterShortUser;
	metrics?: presenterNewsletterMetric;
	post?: Post;
	hub?: presenterShortHub;
	template?: presenterShortEmailTemplate;
	name: string;
}

export interface dataCollection {
	id: string;
	hub_id: string;
	name: string;
	tags: Array<string>;
	slug: string;
	index: number;
	archived: boolean;
	min_role: string;
}

export interface presenterTagWithCount {
	name: string;
	count: number;
	visible: boolean;
}


export interface configEmailSender {
	sending_domain: string;
	sender_name: string;
}

export interface dataHubAdminSettings {
	header_home_url?: string;
	enable_redirects?: boolean;
	email_sender?: configEmailSender;
	enable_similar_content?: boolean;
	enable_org_post_search?: boolean;
	enable_pdf_watermarking?: boolean;
}

const featureToggleKeys = [
	"ai_moderator",
	"mcm",
	"antivirus",
	"disable_custom_html",
	"disableDocumentFileUploads",
]
export type FeatureToggleKey = typeof featureToggleKeys[number];
export const isFeatureToggleKey = (key: string): key is FeatureToggleKey => {
	return featureToggleKeys.includes(key as FeatureToggleKey);
}
export type HubSettingsFeatures = Record<FeatureToggleKey, boolean>;

const cpmFeatureToggleKeys = [
	"Toggles+AILabs",
	"Toggles+HubsAICopywriter",
	'Toggles+HubsAICopywriterPostEnhancement',
	'Toggles+HubsModernNewsletterComposer'
] as const
export type CpmFeatureToggleKey = typeof cpmFeatureToggleKeys[number];
export const isCpmFeatureToggleKey = (key: string): key is CpmFeatureToggleKey => {
	return cpmFeatureToggleKeys.includes(key as CpmFeatureToggleKey);
}
export type CpmFeatureToggles = Record<CpmFeatureToggleKey, boolean>;


export interface dataAIModeratorAutoPost {
	enabled: boolean;
	positive: boolean;
	negative: boolean;
	neutral: boolean;
}

export interface dataAIModeratorSectionOptions {
	sentiment_check: boolean;
	auto_post: dataAIModeratorAutoPost;
}

export interface dataAIModerator {
	ai_consent: boolean;
	ai_consent_updated_at: string;
	post: dataAIModeratorSectionOptions;
	enable_notifications_digest: boolean;
	notifications_frequency: string;
}

export const socialSsoProviders = [
	"facebook",
	"google",
	"linkedin"] as const
export type SocialSsoProvider = typeof socialSsoProviders[number];


export type dataAuthOptions = Record<SocialSsoProvider, boolean> & {
	disable_email_form: boolean;};

export interface SignupTheme {
	id: string;
	name: string;
	shortActiveMessage: string;
	headerBackgroundColor: string;
	backgroundImage: string;
	backgroundImageStyle: string;
	bodyBackgroundColor: string;
	contentBackgroundColor: string;
	borderColor: string;
	titleFont: string;
	titleTextColor: string;
	bodyTextFont: string;
	bodyTextColor: string;
	bodyLinkTextColor: string;
	portalHeaderImage: string;
	portalMobileHeaderImage: string;
	bodyPrimaryTitleFontSize: string;
	bodyPrimaryTitleFontWeight: string;
	bodyParagraphHeadingsFontSize: string;
	bodyTitleFontWeight: string;
	bodyTextFontSize: string;
	bodyLinkFontWeight: string;
	errorTextColor: string;
	footerBackgroundColor: string;
	footerFont: string;
	footerTextColor: string;
	footerLinkTextColor: string;
	footerAlidaLogo: string;
}

export interface dataIcmTheme {
	icmThemes: Array<SignupTheme>;
}

export interface cpmSignupPageHeaderImages {
	desktop: string;
	mobile: string;
}

export interface cpmMemberSignUpLinks {
	Key: string;
	Value: string;
}

export interface cpmCommunitySignupPageContent {
	CommunityId: string;
	PageTitle: string;
	IntroductionText: string;
	ClosingText: string;
	SignUpFormTitle: string;
	StatusMessage: string;
	PortalSignUpPageLink: string;
	SignUpLinkText: string;
	SignUpLinkCommunicationId: string;
	MemberSignUpLinks: Array<cpmMemberSignUpLinks>;
	ShowPageTitle: boolean;
	ShowFirstName: boolean;
	ShowLastName: boolean;
	ShowClosingText: boolean;
	SignInPageShowSignUpMessage: boolean;
	IsSignUpLinkCommunicationIdInvalid: boolean;
	SignUpLinkErrorMessage: string;
	SignInPageShowSignUpLink: boolean;
}

export interface cpmCommunityFooter {
	Id: string;
	CommunityId: string;
	Copyright: string;
	LinkHref1: string;
	LinkText1: string;
	LinkHref2: string;
	LinkText2: string;
	LinkHref3: string;
	LinkText3: string;
	LinkHref4: string;
	LinkText4: string;
	LinkHref5: string;
	LinkText5: string;
	SupportEmail: string;
	SupportLink: string;
	TermsConditionsLink: string;
	PrivacyPolicyLink: string;
}

export interface dataHubSettings {
	header_home_url?: string;
	enable_redirects?: boolean;
	email_sender?: configEmailSender;
	enable_similar_content?: boolean;
	enable_org_post_search?: boolean;
	enable_pdf_watermarking?: boolean;
	feature: HubSettingsFeatures;
	purge_display_name_enabled: boolean;
	purge_display_name: string;
	time_24_hours: boolean;
	about?: string;
	description?: string;
	logo_url?: string;
	login_logo_url?: string;
	logo?: contentImage;
	login_logo?: contentImage;
	cover?: contentImage;
	lang_url: string;
	lang_url_updated_at?: string;
	short_url?: string;
	hide_members?: boolean;
	hide_members_count?: boolean;
	members_user_popup: boolean;
	share_original_source?: boolean;
	open_external_source?: boolean;
	share_from_external_network?: boolean;
	show_spotlight_view_more?: boolean;
	hide_spotlight_collections?: boolean;
	hide_file_embeds?: boolean;
	disable_pressly_digest?: boolean;
	allow_publish_date_override?: boolean;
	open_new_tab?: boolean;
	share_slabs_hover?: boolean;
	leftCover?: boolean;
	disable_infinite_scroll?: boolean;
	disable_subscriber_workflow?: boolean;
	disable_contribution_notifications: boolean;
	show_spotlight_collections?: boolean;
	use_native_email_share?: boolean;
	collaborators_require_approval?: boolean;
	allow_member_submissions?: boolean;
	ai_moderator: dataAIModerator;
	company_contact_info?: string;
	enable_reposts?: boolean;
	enable_forum: boolean;
	disable_contributions?: boolean;
	hide_collaborators?: boolean;
	logout_url?: string;
	disable_member_activities?: boolean;
	welcome_title?: string;
	welcome_message?: string;
	hide_who_liked?: boolean;
	enable_join_now: boolean;
	join_now_url: string;
	non_member_message?: string;
	enable_cookie_consent?: boolean;
	cookie_policy_url?: string;
	cookie_policy_hypertext?: string;
	cookie_policy?: string;
	allow_sso?: boolean;
	sso_sign_in_url?: string;
	auth_options: dataAuthOptions;
	enable_ccpa?: boolean;
	ccpa_terms?: string;
	logout_on_browser_close: boolean;
	cookie_max_age: number;
	next_signin_page: boolean;
	default_collection_id?: string;
	hide_all_collection: boolean;
	pii_consent_custom_text?: string;
	display_name: boolean;
	invalidate_sessions_before?: string;
	enableSignupConfirmPageCustomDestination: boolean;
	signupConfirmPageCustomDestination: string;
	signupPageHeaderLogoCentered: boolean;
	icm_theme?: dataIcmTheme;
	signup_page_header_images?: cpmSignupPageHeaderImages;
	CommunitySignupPageContent?: cpmCommunitySignupPageContent;
	community_signup_page_footer?: cpmCommunityFooter;
	csp_strict_mode: boolean;
}

export interface dataCoverLogoImage {
	url: string;
	enableCustomDimensions: boolean;
	width: number;
	height: number;
}

export interface dataDesktop {
	coverImage: string;
	coverLogoImage: dataCoverLogoImage;
	coverImageTransformationType: string;
	coverImageContainType: string;
	alignment: string;
}

export interface dataMobile {
	coverImage: string;
	coverLogoImage: dataCoverLogoImage;
	coverImageTransformationType: string;
	coverImageContainType: string;
}

export interface dataHubTheme {
	accessibility: boolean;
	desktop: dataDesktop;
	mobile: dataMobile;
	collectionsBackgroundColor: string;
	collectionsFontColor: string;
	coverBackgroundColor: string;
	coverFontColor: string;
	coverHideCover: boolean;
	coverShowTitle: boolean;
	coverTintColorWithOpacity: string;
	coverTintColor: string;
	coverTintOpacity: number;
	coverHideAvatarsAndCounterPill: boolean;
	footerBackgroundColor: string;
	footerFontColor: string;
	headerAccentColor: string;
	headerBackgroundColor: string;
	headerBackgroundOpacity: number;
	headerCentreLogo: boolean;
	headerFontColor: string;
	headerIconColor: string;
	headerLogoImage: string;
	headerBarAlwaysVisible: boolean;
	hubAccentColor: string;
	hubBodyFontColor: string;
	hubBodyFontFamily: string;
	hubBodyFontLetterSpacing: string;
	hubBodyFontStyle: string;
	hubBodyFontWeight: string;
	hubBodyFontURL: string;
	hubDetailFontColor: string;
	hubDetailFontFamily: string;
	hubDetailFontLetterSpacing: string;
	hubDetailFontStyle: string;
	hubDetailFontURL: string;
	hubDetailFontWeight: string;
	hubHeadlineFontColor: string;
	hubHeadlineFontFamily: string;
	hubHeadlineFontLetterSpacing: string;
	hubHeadlineFontStyle: string;
	hubHeadlineFontURL: string;
	hubHeadlineFontWeight: string;
	hubLinkFontColor: string;
	hubMenuFontFamily: string;
	hubMenuFontLetterSpacing: string;
	hubMenuFontStyle: string;
	hubMenuFontURL: string;
	hubMenuFontWeight: string;
	streamAutoplay: boolean;
	streamBackgroundColor: string;
	streamIconColor: string;
	streamTileBackdropColor: string;
	streamUseTiles: boolean;
}

export interface dataMailingListEtc {
	sparq3_filter?: dataSparq3Filter
  }

export type sparq3FilterPayload = {
	id: string
	hub_id: string
	user_id: string
	name: string
	count: number
	created_at?: string
	updated_at?: string
	type: string
	etc: dataMailingListEtc
  }

export interface dataHubSparq3Settings {
	communityId: string;
	communityName: string;
	serviceProviderId: string;
	portalAddress: string;
	pod: string;
	applicationId: string;
	applicationName: string;
	tenantName: string;
	tenantType: string;
	panelId: string;
}

export interface dataContactInfo {
	business_name?: string;
	email?: string;
	from_email_address?: string;
	from_name?: string;
	street?: string;
	city_state?: string;
	zip_code?: string;
	country?: string;
	from_template?: boolean;
	support_email?: string;
	support?: string;
	privacy_policy?: string;
	terms_conditions?: string;
}

export interface dataHub {
	id: string;
	account_id: string;
	uid: string;
	name: string;
	host_https: boolean;
	host: string;
	host_path: string;
	visibility: string;
	deleted_by?: string;
	description: string;
	website_index_url: string;
	website_url: string;
	logo_url: string;
	cover_url: string;
	settings: dataHubSettings;
	theme: dataHubTheme;
	sparq3?: dataHubSparq3Settings;
	owner_count: number;
	moderator_count: number;
	collaborator_count: number;
	member_count: number;
	guest_count: number;
	subscriber_count: number;
	user_count: number;
	created_at: string;
	updated_at: string;
	published_at?: string;
	deleted_at?: string;
	locale: string;
	meta_title?: string;
	meta_description?: string;
	meta_canonical?: string;
	type: string;
	contact_info: dataContactInfo;
	footer_links?: Array<dataFooterLink>;
}

export interface HubRequest {
	account_id: string;
	uid: string;
	name: string;
	host_https: boolean;
	host: string;
	host_path: string;
	visibility: string;
	deleted_by?: string;
	description: string;
	website_index_url: string;
	website_url: string;
	logo_url: string;
	cover_url: string;
	settings: dataHubSettings;
	theme: dataHubTheme;
	sparq3?: dataHubSparq3Settings;
	owner_count: number;
	moderator_count: number;
	collaborator_count: number;
	member_count: number;
	guest_count: number;
	subscriber_count: number;
	user_count: number;
	created_at: string;
	updated_at: string;
	published_at?: string;
	deleted_at?: string;
	locale: string;
	meta_title?: string;
	meta_description?: string;
	meta_canonical?: string;
	type: string;
	contact_info: dataContactInfo;
	footer_links?: Array<dataFooterLink>;
	id?: string;
}

export interface dataUserAccountSettings {
	onboarding?: Array<string>;
	tutorials?: Array<string>;
	help?: boolean;
	social_share?: { [key: string]: any };
	activity_unread?: number;
	pending_invites?: number;
	activity_read_id?: string;
	bookmarklet_hub_id?: string;
	email_sender?: configEmailSender;
	privacy_policy?: string;
	footer_logo_url?: string;
	source: string;
}

export interface dataOrganizationSparq3Settings {
	pod: string;
	applicationId: string;
	applicationName: string;
	tenantName: string;
	tenantType: string;
	panelId: string;
}

export interface dataUserSparq3Settings {
	applicationIdToGusUserId?: { [key: string]: string };
	panelIdToMemberId?: { [key: string]: string };
	communityIdToMemberId?: { [key: string]: string };
	admin: boolean;
}

export interface dataAccountSparq3Settings {
	pod: string;
	applicationId: string;
	applicationName: string;
	tenantName: string;
	tenantType: string;
	panelId: string;
	applicationIdToGusUserId?: { [key: string]: string };
	panelIdToMemberId?: { [key: string]: string };
	communityIdToMemberId?: { [key: string]: string };
	admin: boolean;
}

export interface dataOrgLoginSettings {
	disable_username_email?: boolean;
	allow_google?: boolean;
	allow_facebook?: boolean;
	allow_linkedin?: boolean;
	allow_twitter?: boolean;
	allow_slack?: boolean;
	logout_url?: string;
	allow_sso?: boolean;
	sso_sign_in_url?: string;
	sso_text?: string;
	sso_url?: string;
}

export interface dataOrgAppSettings {
	default_join_hub_id?: string;
	hide_create_hub?: boolean;
	hide_create_org?: boolean;
	hide_request_to_join_org?: boolean;
	enable_member_engagement_dashboard?: boolean;
	enable_nested_comments?: boolean;
	enable_profile_variables?: boolean;
	enable_email_updates?: boolean;
	enable_sso?: boolean;
}

export interface dataOrgSettings {
	default_user_role: string;
	login_settings?: dataOrgLoginSettings;
	app_settings?: dataOrgAppSettings;
}

export interface dataAccount {
	id: string;
	type: string;
	username: string;
	name: string;
	status?: string;
	company?: string;
	title: string;
	description: string;
	avatar_url: string;
	cover_url: string;
	created_at: string;
	updated_at: string;
	deleted_by?: string;
	deleted_at?: string;
	uuid: string;
	etc?: dataUserAccountSettings;
	sparq3?: dataAccountSparq3Settings;
	creator_id?: string;
	domains?: Array<string>;
	email_confirmed: boolean;
	contact_info: dataContactInfo;
	locale?: string;
	settings?: dataOrgSettings;
}

export interface presenterAccount {
	id: string;
	type: string;
	username: string;
	name: string;
	status?: string;
	company?: string;
	title: string;
	description: string;
	avatar_url: string;
	cover_url: string;
	created_at: string;
	updated_at: string;
	deleted_by?: string;
	deleted_at?: string;
	uuid: string;
	creator_id?: string;
	domains?: Array<string>;
	email_confirmed: boolean;
	locale?: string;
	settings?: dataOrgSettings;
	role?: string;
	email?: string;
	etc?: any;
	customer?: any;
	contact_info?: dataContactInfo;
	sparq3?: dataAccountSparq3Settings;
}

export interface UserInvite {
	id: string;
	is_request: boolean;
	is_batch?: boolean;
	hash: string;
	granter_id?: string;
	invitee_id?: string;
	invitee_email?: string;
	invitee_role: string;
	hub_id?: string;
	org_id?: string;
	message: string;
	created_at?: string;
	expires_at?: string;
	updated_at?: string;
	status: string;
	batch_counter?: number;
	batch_max?: number;
}

export interface hubpermsUser {
	view_hamburger_menu: boolean;
	manage_user_settings: boolean;
	change_email: boolean;
}

export interface hubpermsManagePostTypes {
	published: boolean;
	scheduled: boolean;
	drafts: boolean;
	submissions: boolean;
	comments: boolean;
}

export interface hubpermsManageContent {
	posts: hubpermsManagePostTypes;
	feeds: boolean;
	embeds: boolean;
	newsletters: boolean;
	newsletters_mailing_lists: boolean;
	oidc_provider: boolean;
	collections: boolean;
}

export interface hubpermsManageProfileVariables {
	view: boolean;
	edit: boolean;
}

export interface hubpermsHubSettings {
	role: string;
	manage: boolean;
	change_privacy: boolean;
	change_locale: boolean;
	view_sparq3_ids: boolean;
	profile_variables: hubpermsManageProfileVariables;
}

export interface hubpermsPosts {
	view: boolean;
	view_metrics: boolean;
	manage_owned: boolean;
	manage_all: boolean;
	publish: boolean;
	submit: boolean;
	like: boolean;
	contribute: boolean;
	share: boolean;
	download_contributions: boolean;
}

export interface hubpermsContributions {
	manage_owned: boolean;
	manage_all: boolean;
}

export interface hubpermsTeamView {
	guests: boolean;
	members: boolean;
	member_ids: boolean;
	member_count: boolean;
	collaborators: boolean;
}

export interface hubpermsRoles {
	member: boolean;
	collaborator: boolean;
	moderator: boolean;
	owner: boolean;
}

export interface hubpermsTeamChangeRole {
	from: hubpermsRoles;
	to: hubpermsRoles;
}

export interface hubpermsTeam {
	view: hubpermsTeamView;
	invites: hubpermsRoles;
	change_role: hubpermsTeamChangeRole;
	open_user_popup: boolean;
}

export interface hubpermsCollections {
	view_collections: boolean;
}

export interface hubpermsOidc {
	view: boolean;
}

export interface hubpermsSessions {
	invalidate_sessions: boolean;
}

export interface hubpermsPermissions {
	user: hubpermsUser;
	manage_content: hubpermsManageContent;
	hub_settings: hubpermsHubSettings;
	posts: hubpermsPosts;
	contributions: hubpermsContributions;
	team: hubpermsTeam;
	collections: hubpermsCollections;
	oidc: hubpermsOidc;
	sessions: hubpermsSessions;
}

export interface presenterHubUserContext {
	role: string;
	org_role: string;
	hub_role: string;
	subscribed: boolean;
	invite?: UserInvite;
	request?: UserInvite;
	perms: hubpermsPermissions;
	password_update: boolean;
	member_id: string;
}

export interface presenterSSOButton {
	provider_id: number;
	provider_type: string;
	title: string;
	bg_color: string;
	icon_url: string;
	method: string;
	url: string;
}

export interface cpmSignupPageWelcomeMessage {
	pageTitle: string;
	introductionText: string;
	showPageTitle: boolean;
}

export interface cpmSignupForm {
	closingText: string;
	signUpFormTitle: string;
	showFirstName: boolean;
	showLastName: boolean;
	showClosingText: boolean;
}

export interface cpmSignupData {
	communityId: string;
	pageTitle: string;
	memberSignUpLinks: Array<string>;
	isSignUpLinkCommunicationIdInvalid: boolean;
}

export interface cpmSignupPage {
	welcomeMessage: cpmSignupPageWelcomeMessage;
	signUpForm: cpmSignupForm;
	data: cpmSignupData;
	theme: SignupTheme;
	footer_copyright: string;
}

export interface Hub {
	id: string;
	account_id: string;
	application_id: string;
	uid: string;
	name: string;
	host_https: boolean;
	host: string;
	host_path: string;
	visibility: string;
	deleted_by?: string;
	description: string;
	website_index_url: string;
	website_url: string;
	logo_url: string;
	cover_url: string;
	settings: dataHubSettings;
	theme: dataHubTheme;
	created_at: string;
	updated_at: string;
	published_at?: string;
	deleted_at?: string;
	locale: string;
	meta_title?: string;
	meta_description?: string;
	meta_canonical?: string;
	type: string;
	footer_links?: Array<dataFooterLink>;
	account: presenterAccount;
	url_path: string;
	hub_url: string;
	invite_url?: string;
	pressly_hub_url: string;
	owner_count?: number;
	moderator_count?: number;
	collaborator_count?: number;
	member_count?: number;
	guest_count?: number;
	subscriber_count?: number;
	user_count?: number;
	follower_count?: number;
	user_context: presenterHubUserContext;
	sso_buttons?: Array<presenterSSOButton>;
	customer?: any;
	sparq3?: dataHubSparq3Settings;
	contact_info?: dataContactInfo;
	role?: string;
	signupPage?: cpmSignupPage;
	features: CpmFeatureToggles;
}

export interface CreateOauthProviderRequest {
	hub_id: string;
	active: boolean;
	label: string;
	client_id: string;
	client_secret: string;
	authentication_url?: string;
	refresh_token_url?: string;
	revoke_token_url?: string;
	user_info_url?: string;
	callback_url?: string;
	public_key_url?: string;
	metadata_url?: string;
	issuer_url?: string;
	custom_button_text?: string;
}

export interface OauthProvider {
	id: string;
	hub_id: string;
	label: string;
	client_id: string;
	client_secret: string;
	authentication_url: string;
	refresh_token_url: string;
	revoke_token_url: string;
	user_info_url: string;
	callback_url: string;
	active: boolean;
	public_key_url: string;
	issuer_url: string;
	metadata_url?: string;
	custom_button_text?: string;
	deleted_at?: string;
}

export interface Sparq3Organization {
	communityId: any;
	panelId: string;
	applicationName: string;
	applicationId: string;
	gusUserId: string;
	pod: string;
}

export interface CreateOrganizationRequest {
	name: string;
	username: string;
	sparq3?: Sparq3Organization;
}

export interface orgpermsUser {
	manage_user_settings: boolean;
}

export interface orgpermsPermissions {
	user: orgpermsUser;
}

export interface presenterOrgUserContext {
	perms: orgpermsPermissions;
	password_update: boolean;
}

export interface Organization {
	id: string;
	type: string;
	username: string;
	name: string;
	status?: string;
	company?: string;
	title: string;
	description: string;
	avatar_url: string;
	cover_url: string;
	created_at: string;
	updated_at: string;
	deleted_by?: string;
	deleted_at?: string;
	uuid: string;
	creator_id?: string;
	domains?: Array<string>;
	email_confirmed: boolean;
	locale?: string;
	settings?: dataOrgSettings;
	url: string;
	invite_url: string;
	role?: string;
	email?: any;
	etc?: any;
	customer?: string;
	contact_info?: dataContactInfo;
	sparq3?: dataAccountSparq3Settings;
	user_context: presenterOrgUserContext;
}

export interface OrganizationWithJWT {
	org: Organization;
	jwt: string;
}

export interface Empty {}

export interface Page {
	page: number;
	size: number;
}

export interface User {
	id: string;
	type: string;
	username: string;
	name: string;
	status?: string;
	company?: string;
	title: string;
	description: string;
	avatar_url: string;
	cover_url: string;
	created_at: string;
	updated_at: string;
	deleted_by?: string;
	deleted_at?: string;
	uuid: string;
	creator_id?: string;
	domains?: Array<string>;
	email_confirmed: boolean;
	locale?: string;
	settings?: dataOrgSettings;
	role?: string;
	memberId?: string;
	isSparqMember: boolean;
	gusUserId?: string;
	isSparqAdmin: boolean;
	score?: number;
	shadow?: boolean;
	email?: any;
	etc?: any;
	customer?: any;
	contact_info?: any;
	sparq3?: dataAccountSparq3Settings;
}

export interface Pages {
	next?: Page;
}

export interface PublishedAtRange {
	start?: string;
	end?: string;
}

export interface CommentFilter {
	postIDs?: Array<string>;
	created_at_range?: PublishedAtRange;
}

export interface MemberGroup {
	uid: string;
	name: string;
}

export interface MemberSignupDataIdentityVariable {
	type: string;
	value: string;
}

export interface MemberSignupData {
	memberId: string;
	signUpPage: cpmSignupPage;
	identityVariable: MemberSignupDataIdentityVariable;
	CpmError: string;
}

export interface MemberVariableCategory {
	id: string;
	hub_id: string;
	name: string;
}

export interface MemberVariableValue {
	name: string;
	value: any;
	sparq_name: string;
	sparq_id: string;
	last_updated_at: string;
	source: string;
}

export interface MemberVariableSettings {
	id: string;
	sparq_id: string;
	hub_id: string;
	read_only: boolean;
	visible: boolean;
	visible_to_members: boolean;
	category?: MemberVariableCategory;
	member_facing_name: string;
	type: string;
	data_type: string;
	selected_member_values: Array<MemberVariableValue>;
	member_variable_values: Array<MemberVariableValue>;
	order: number;
}

export interface OrderBy {
	field?: string;
	orderAsc?: boolean;
}

export interface NewsletterFilters {
	status: Array<string>;
	orderBy?: OrderBy;
}

export interface PostsFilters {
	collectionId?: string;
	collectionSlug?: string;
	tag?: string;
	types: Array<string>;
	statuses: Array<string>;
}

export interface QuickPoll {
	name: string;
	url: string;
}

export interface dataWidget {
	id: string;
	name: string;
	frequency: number;
	offset: number;
	format: string;
	width: string;
	height: string;
	context: string;
	type: string;
	url: string;
	html: string;
	target_url: string;
	hub_id: string;
	collection_ids: string;
	all_collections: boolean;
	enabled: boolean;
	post_ids: string;
	title?: string;
	description?: string;
	created_at?: string;
}

export interface Widget {
	id: string;
	name: string;
	frequency: number;
	format: string;
	width: string;
	height: string;
	context: string;
	type: string;
	url: string;
	html: string;
	target_url: string;
	hub_id: string;
	collection_ids: string;
	all_collections: boolean;
	enabled: boolean;
	post_ids: string;
	title?: string;
	description?: string;
	created_at?: string;
	tag: string;
	iframe_content: string;
	offset: number;
	posts: Array<Post>;
}

export interface AddonFilters {
	disabled?: boolean;
}

export interface AddonConfig {
	id: string;
	label: string;
	hub_id: string;
	is_enabled: boolean;
	values: Array<string>;
	addon_type: string;
}

export interface LoginResponse {
	jwt: string;
}

export interface LookupHubUser {
	email?: string;
	action: string;
	redirect_url?: string;
}

export interface MemberSignUpPage {
	memberState: string;
	url: string;
}

export interface OrgAdminGetOrganizationsOrder {
	id: string;
	name: string;
	uid: string;
	created_at: string;
}

export interface UpdateOauthProviderRequest {
	id: string;
	hub_id: string;
	active: boolean;
	label: string;
	client_id: string;
	client_secret: string;
	authentication_url?: string;
	refresh_token_url?: string;
	revoke_token_url?: string;
	user_info_url?: string;
	callback_url?: string;
	public_key_url?: string;
	metadata_url?: string;
	issuer_url?: string;
	custom_button_text?: string;
}

export interface UpdateAvatarRequest {
	user_id: string;
	avatar_url: string;
}

export interface UpdateDisplayNameRequest {
	user_id: string;
	display_name: string;
}

export interface UpdateEmailRequest {
	user_id: string;
	email: string;
}

export interface HubUser {
	id: string;
	user_id: string;
	hub_id: string;
	pii_consent?: string;
	purged: boolean;
	display_name?: string;
}

export interface HubsAPI {
	activateMember(args: ActivateMemberArgs, headers?: object): Promise<ActivateMemberReturn>;
	checkDisplayNameUniqueness(
		args: CheckDisplayNameUniquenessArgs,
		headers?: object
	): Promise<CheckDisplayNameUniquenessReturn>;
	cloneNewsletter(args: CloneNewsletterArgs, headers?: object): Promise<CloneNewsletterReturn>;
	createCollection(args: CreateCollectionArgs, headers?: object): Promise<CreateCollectionReturn>;
	createHub(args: CreateHubArgs, headers?: object): Promise<CreateHubReturn>;
	createOauthProvider(
		args: CreateOauthProviderArgs,
		headers?: object
	): Promise<CreateOauthProviderReturn>;
	createOrganization(
		args: CreateOrganizationArgs,
		headers?: object
	): Promise<CreateOrganizationReturn>;
	createPost(args: CreatePostArgs, headers?: object): Promise<CreatePostReturn>;
	deleteCollection(args: DeleteCollectionArgs, headers?: object): Promise<DeleteCollectionReturn>;
	deleteDraftNewsletter(
		args: DeleteDraftNewsletterArgs,
		headers?: object
	): Promise<DeleteDraftNewsletterReturn>;
	deleteInvite(args: DeleteInviteArgs, headers?: object): Promise<DeleteInviteReturn>;
	deleteOauthProvider(
		args: DeleteOauthProviderArgs,
		headers?: object
	): Promise<DeleteOauthProviderReturn>;
	deletePost(args: DeletePostArgs, headers?: object): Promise<DeletePostReturn>;
	embedLink(args: EmbedLinkArgs, headers?: object): Promise<EmbedLinkReturn>;
	featurePost(args: FeaturePostArgs, headers?: object): Promise<FeaturePostReturn>;
	getCollaborators(args: GetCollaboratorsArgs, headers?: object): Promise<GetCollaboratorsReturn>;
	getCollection(args: GetCollectionArgs, headers?: object): Promise<GetCollectionReturn>;
	getFeaturedPosts(args: GetFeaturedPostsArgs, headers?: object): Promise<GetFeaturedPostsReturn>;
	getHub(args: GetHubArgs, headers?: object): Promise<GetHubReturn>;
	getHubComments(args: GetHubCommentsArgs, headers?: object): Promise<GetHubCommentsReturn>;
	getHubFromUrl(args: GetHubFromUrlArgs, headers?: object): Promise<GetHubFromUrlReturn>;
	getMemberGroups(args: GetMemberGroupsArgs, headers?: object): Promise<GetMemberGroupsReturn>;
	getMemberSignupData(
		args: GetMemberSignupDataArgs,
		headers?: object
	): Promise<GetMemberSignupDataReturn>;
	getMemberVariablesSettings(
		args: GetMemberVariablesSettingsArgs,
		headers?: object
	): Promise<GetMemberVariablesSettingsReturn>;
	getMemberVariablesValues(
		args: GetMemberVariablesValuesArgs,
		headers?: object
	): Promise<GetMemberVariablesValuesReturn>;
	getMembers(args: GetMembersArgs, headers?: object): Promise<GetMembersReturn>;
	getNewsletter(args: GetNewsletterArgs, headers?: object): Promise<GetNewsletterReturn>;
	getNewsletters(args: GetNewslettersArgs, headers?: object): Promise<GetNewslettersReturn>;
	getOwnPosts(args: GetOwnPostsArgs, headers?: object): Promise<GetOwnPostsReturn>;
	getPinnedPosts(args: GetPinnedPostsArgs, headers?: object): Promise<GetPinnedPostsReturn>;
	getPost(args: GetPostArgs, headers?: object): Promise<GetPostReturn>;
	getPostContributions(
		args: GetPostContributionsArgs,
		headers?: object
	): Promise<GetPostContributionsReturn>;
	getPosts(args: GetPostsArgs, headers?: object): Promise<GetPostsReturn>;
	getSessionHubUser(
		args: GetSessionHubUserArgs,
		headers?: object
	): Promise<GetSessionHubUserReturn>;
	getSessionUser(headers?: object): Promise<GetSessionUserReturn>;
	getTouchpointQuickPollLinks(
		args: GetTouchpointQuickPollLinksArgs,
		headers?: object
	): Promise<GetTouchpointQuickPollLinksReturn>;
	getUser(args: GetUserArgs, headers?: object): Promise<GetUserReturn>;
	getUsers(args: GetUsersArgs, headers?: object): Promise<GetUsersReturn>;
	getVersion(headers?: object): Promise<GetVersionReturn>;
	getWidgets(args: GetWidgetsArgs, headers?: object): Promise<GetWidgetsReturn>;
	hidePost(args: HidePostArgs, headers?: object): Promise<HidePostReturn>;
	invalidateSessions(
		args: InvalidateSessionsArgs,
		headers?: object
	): Promise<InvalidateSessionsReturn>;
	likePost(args: LikePostArgs, headers?: object): Promise<LikePostReturn>;
	listAddons(args: ListAddonsArgs, headers?: object): Promise<ListAddonsReturn>;
	listAddonsMap(args: ListAddonsMapArgs, headers?: object): Promise<ListAddonsMapReturn>;
	listInvites(args: ListInvitesArgs, headers?: object): Promise<ListInvitesReturn>;
	listOauthProviders(
		args: ListOauthProvidersArgs,
		headers?: object
	): Promise<ListOauthProvidersReturn>;
	login(args: LoginArgs, headers?: object): Promise<LoginReturn>;
	lookupHubUser(args: LookupHubUserArgs, headers?: object): Promise<LookupHubUserReturn>;
	memberSignup(args: MemberSignupArgs, headers?: object): Promise<MemberSignupReturn>;
	orgAdminGetActiveHubs(
		args: OrgAdminGetActiveHubsArgs,
		headers?: object
	): Promise<OrgAdminGetActiveHubsReturn>;
	orgAdminGetHubs(args: OrgAdminGetHubsArgs, headers?: object): Promise<OrgAdminGetHubsReturn>;
	orgAdminGetOrganizations(
		args: OrgAdminGetOrganizationsArgs,
		headers?: object
	): Promise<OrgAdminGetOrganizationsReturn>;
	pinPost(args: PinPostArgs, headers?: object): Promise<PinPostReturn>;
	recordCCPA(args: RecordCCPAArgs, headers?: object): Promise<RecordCCPAReturn>;
	refreshSession(args: RefreshSessionArgs, headers?: object): Promise<RefreshSessionReturn>;
	reorderCollection(
		args: ReorderCollectionArgs,
		headers?: object
	): Promise<ReorderCollectionReturn>;
	searchPosts(args: SearchPostsArgs, headers?: object): Promise<SearchPostsReturn>;
	setMemberPassword(
		args: SetMemberPasswordArgs,
		headers?: object
	): Promise<SetMemberPasswordReturn>;
	showPost(args: ShowPostArgs, headers?: object): Promise<ShowPostReturn>;
	unfeaturePost(args: UnfeaturePostArgs, headers?: object): Promise<UnfeaturePostReturn>;
	unlikePost(args: UnlikePostArgs, headers?: object): Promise<UnlikePostReturn>;
	unpinPost(args: UnpinPostArgs, headers?: object): Promise<UnpinPostReturn>;
	updateCollection(args: UpdateCollectionArgs, headers?: object): Promise<UpdateCollectionReturn>;
	updateHub(args: UpdateHubArgs, headers?: object): Promise<UpdateHubReturn>;
	updateMemberVariables(
		args: UpdateMemberVariablesArgs,
		headers?: object
	): Promise<UpdateMemberVariablesReturn>;
	updateOauthProvider(
		args: UpdateOauthProviderArgs,
		headers?: object
	): Promise<UpdateOauthProviderReturn>;
	updatePost(args: UpdatePostArgs, headers?: object): Promise<UpdatePostReturn>;
	updateUserAvatar(args: UpdateUserAvatarArgs, headers?: object): Promise<UpdateUserAvatarReturn>;
	updateUserDisplayName(
		args: UpdateUserDisplayNameArgs,
		headers?: object
	): Promise<UpdateUserDisplayNameReturn>;
	updateUserEmail(args: UpdateUserEmailArgs, headers?: object): Promise<UpdateUserEmailReturn>;
	upsertHubUser(args: UpsertHubUserArgs, headers?: object): Promise<UpsertHubUserReturn>;
}

export interface ActivateMemberArgs {
	url: string;
}

export interface ActivateMemberReturn {
	status: ActivateMemberStatus;
}
export interface CheckDisplayNameUniquenessArgs {
	hubId: string;
	displayName: string;
}

export interface CheckDisplayNameUniquenessReturn {
	isUnique: boolean;
}
export interface CloneNewsletterArgs {
	hubId: string;
	newsletterId: string;
}

export interface CloneNewsletterReturn {
	newsletter: Newsletter;
}
export interface CreateCollectionArgs {
	hubId: string;
	name: string;
}

export interface CreateCollectionReturn {
	collection: Collection;
}
export interface CreateHubArgs {
	hubRequest: HubRequest;
}

export interface CreateHubReturn {
	ret1: Hub;
}
export interface CreateOauthProviderArgs {
	hubId: string;
	provider: CreateOauthProviderRequest;
}

export interface CreateOauthProviderReturn {
	ret1: OauthProvider;
}
export interface CreateOrganizationArgs {
	organizationRequest: CreateOrganizationRequest;
}

export interface CreateOrganizationReturn {
	organization: OrganizationWithJWT;
}
export interface CreatePostArgs {
	hubId: string;
	newPost: Post;
}

export interface CreatePostReturn {
	post: Post;
}
export interface DeleteCollectionArgs {
	hubId: string;
	collectionId: string;
}

export interface DeleteCollectionReturn {}
export interface DeleteDraftNewsletterArgs {
	hubId: string;
	newsletterId: string;
}

export interface DeleteDraftNewsletterReturn {
	_: Empty;
}
export interface DeleteInviteArgs {
	hubId: string;
	email: string;
}

export interface DeleteInviteReturn {
	_: Empty;
}
export interface DeleteOauthProviderArgs {
	hubId: string;
	providerId: string;
}

export interface DeleteOauthProviderReturn {
	response: Empty;
}
export interface DeletePostArgs {
	hubId: string;
	postId: string;
}

export interface DeletePostReturn {
	_: Empty;
}
export interface EmbedLinkArgs {
	hubId: string;
	url: string;
}

export interface EmbedLinkReturn {
	asset: Asset;
}
export interface FeaturePostArgs {
	hubId: string;
	postId: string;
}

export interface FeaturePostReturn {
	_: Empty;
}
export interface GetCollaboratorsArgs {
	hubId: string;
	page: Page;
}

export interface GetCollaboratorsReturn {
	users: Array<User>;
	pages: Pages;
}
export interface GetCollectionArgs {
	hubId: string;
	collectionId: string;
}

export interface GetCollectionReturn {
	collection: Collection;
}

export interface GetFeaturedPostsArgs {
	hubId: string;
}

export interface GetFeaturedPostsReturn {
	featuredPosts: Array<Post>;
}
export interface GetHubArgs {
	hubId: string;
	syncFromICM: boolean;
}

export interface GetHubReturn {
	hub: Hub;
}
export interface GetHubCommentsArgs {
	hubId: string;
	filter: CommentFilter;
	page: Page;
}

export interface GetHubCommentsReturn {
	comments: Array<Post>;
	pages: Pages;
}
export interface GetHubFromUrlArgs {
	url: string;
	syncFromICM: boolean;
}

export interface GetHubFromUrlReturn {
	hub: Hub;
}
export interface GetMemberGroupsArgs {
	hubId: string;
}

export interface GetMemberGroupsReturn {
	memberGroups: Array<MemberGroup>;
}
export interface GetMemberSignupDataArgs {
	url: string;
}

export interface GetMemberSignupDataReturn {
	memberSignupData: MemberSignupData;
}
export interface GetMemberVariablesSettingsArgs {
	hubId: string;
}

export interface GetMemberVariablesSettingsReturn {
	memberVariablesSettings: Array<MemberVariableSettings>;
}
export interface GetMemberVariablesValuesArgs {
	hubId: string;
	memberId: string;
}

export interface GetMemberVariablesValuesReturn {
	memberVariablesValue: Array<MemberVariableValue>;
}
export interface GetMembersArgs {
	hubId: string;
	page: Page;
}

export interface GetMembersReturn {
	users: Array<User>;
	pages: Pages;
}
export interface GetNewsletterArgs {
	hubId: string;
	newsletterId: string;
}

export interface GetNewsletterReturn {
	newsletter: Newsletter;
}
export interface GetNewslettersArgs {
	hubId: string;
	filters: NewsletterFilters;
	page: Page;
}

export interface GetNewslettersReturn {
	newsletters: Array<Newsletter>;
	pages: Pages;
}
export interface GetOwnPostsArgs {
	hubId: string;
	page: Page;
	filters: PostsFilters;
}

export interface GetOwnPostsReturn {
	posts: Array<Post>;
	pages: Pages;
}
export interface GetPinnedPostsArgs {
	hubId: string;
}

export interface GetPinnedPostsReturn {
	pinnedPosts: Array<Post>;
}
export interface GetPostArgs {
	hubId: string;
	postId: string;
}

export interface GetPostReturn {
	post: Post;
}
export interface GetPostContributionsArgs {
	hubId: string;
	postId: string;
	page: Page;
}

export interface GetPostContributionsReturn {
	contributions: Array<Post>;
	pages: Pages;
}
export interface GetPostsArgs {
	hubId: string;
	page: Page;
	filters: PostsFilters;
}

export interface GetPostsReturn {
	posts: Array<Post>;
	pages: Pages;
}
export interface GetSessionHubUserArgs {
	hubId: string;
}

export interface GetSessionHubUserReturn {
	user: User;
	expiresIn: number;
}
export interface GetSessionUserArgs {}

export interface GetSessionUserReturn {
	user: User;
}
export interface GetTouchpointQuickPollLinksArgs {
	hubId: string;
}

export interface GetTouchpointQuickPollLinksReturn {
	hubsQuickPollLinks: Array<QuickPoll>;
}
export interface GetUserArgs {
	hubId: string;
	userId: string;
}

export interface GetUserReturn {
	user: User;
}
export interface GetUsersArgs {
	hubId: string;
	roles: Array<string>;
	page: Page;
}

export interface GetUsersReturn {
	users: Array<User>;
	pages: Pages;
}
export interface GetVersionArgs {}

export interface GetVersionReturn {
	version: string;
}
export interface GetWidgetsArgs {
	hubId: string;
}

export interface GetWidgetsReturn {
	onlyWidgets: Array<Widget>;
	featuredPosts: Array<Post>;
	pinnedPosts: Array<Post>;
}
export interface HidePostArgs {
	hubId: string;
	postId: string;
}

export interface HidePostReturn {
	post: Post;
}
export interface InvalidateSessionsArgs {
	hubId: string;
}

export interface InvalidateSessionsReturn {
	ret1: Hub;
}
export interface LikePostArgs {
	hubId: string;
	postId: string;
}

export interface LikePostReturn {
	_: Empty;
}
export interface ListAddonsArgs {
	hubId: string;
	filters: AddonFilters;
}

export interface ListAddonsReturn {
	addons: Array<AddonConfig>;
}
export interface ListAddonsMapArgs {
	hubId: string;
	filters: AddonFilters;
}

export interface ListAddonsMapReturn {
	addons: { [key: string]: Array<AddonConfig> };
}
export interface ListInvitesArgs {
	hubId: string;
	query: string;
	page: Page;
}

export interface ListInvitesReturn {
	userInvites: Array<UserInvite>;
	pages: Pages;
}
export interface ListOauthProvidersArgs {
	hubId: string;
}

export interface ListOauthProvidersReturn {
	providers: Array<OauthProvider>;
}
export interface LoginArgs {
	hubID: string;
	email: string;
	password: string;
}

export interface LoginReturn {
	response: LoginResponse;
}
export interface LookupHubUserArgs {
	hubId: string;
	email: string;
}

export interface LookupHubUserReturn {
	lookupHubUser: LookupHubUser;
}
export interface MemberSignupArgs {
	url: string;
	email: string;
	memberId: string;
	firstName: string;
	lastName: string;
}

export interface MemberSignupReturn {
	memberSignupPage: MemberSignUpPage;
}
export interface OrgAdminGetActiveHubsArgs {
	search: string;
	page: Page;
}

export interface OrgAdminGetActiveHubsReturn {
	hubs: Array<Hub>;
	pages: Pages;
}
export interface OrgAdminGetHubsArgs {
	search: string;
	page: Page;
}

export interface OrgAdminGetHubsReturn {
	hubs: Array<Hub>;
	pages: Pages;
}
export interface OrgAdminGetOrganizationsArgs {
	search: string;
	page: Page;
	order: OrgAdminGetOrganizationsOrder;
}

export interface OrgAdminGetOrganizationsReturn {
	orgs: Array<Organization>;
	pages: Pages;
}
export interface PinPostArgs {
	hubId: string;
	postId: string;
	position: number;
}

export interface PinPostReturn {
	_: Empty;
}
export interface RecordCCPAArgs {
	hubId: string;
	firstName: string;
	lastName: string;
	email: string;
}

export interface RecordCCPAReturn {
	response: Empty;
}
export interface RefreshSessionArgs {
	hubId: string;
}

export interface RefreshSessionReturn {
	expiresIn: number;
}
export interface ReorderCollectionArgs {
	hubId: string;
	collectionList: Array<string>;
}

export interface ReorderCollectionReturn {
	collections: Array<Collection>;
}
export interface SearchPostsArgs {
	hubId: string;
	search: string;
	withContributions: boolean;
	page: Page;
}

export interface SearchPostsReturn {
	posts: Array<Post>;
	pages: Pages;
}
export interface SetMemberPasswordArgs {
	url: string;
	password: string;
}

export interface SetMemberPasswordReturn {
	response: Empty;
}
export interface ShowPostArgs {
	hubId: string;
	postId: string;
}

export interface ShowPostReturn {
	post: Post;
}
export interface UnfeaturePostArgs {
	hubId: string;
	postId: string;
}

export interface UnfeaturePostReturn {
	_: Empty;
}
export interface UnlikePostArgs {
	hubId: string;
	postId: string;
}

export interface UnlikePostReturn {
	_: Empty;
}
export interface UnpinPostArgs {
	hubId: string;
	postId: string;
}

export interface UnpinPostReturn {
	_: Empty;
}
export interface UpdateCollectionArgs {
	hubId: string;
	updatedCollection: Collection;
}

export interface UpdateCollectionReturn {
	collection: Collection;
}
export interface UpdateHubArgs {
	hubId: string;
	updatedHub: Hub;
}

export interface UpdateHubReturn {
	hub: Hub;
}
export interface UpdateMemberVariablesArgs {
	hubId: string;
	memberVariableSettings: Array<MemberVariableSettings>;
}

export interface UpdateMemberVariablesReturn {
	empty: Empty;
}
export interface UpdateOauthProviderArgs {
	hubId: string;
	provider: UpdateOauthProviderRequest;
}

export interface UpdateOauthProviderReturn {
	ret1: OauthProvider;
}
export interface UpdatePostArgs {
	hubId: string;
	postId: string;
	postUpdate: Post;
}

export interface UpdatePostReturn {
	response: Post;
}
export interface UpdateUserAvatarArgs {
	hubId: string;
	avatarUrl: UpdateAvatarRequest;
}

export interface UpdateUserAvatarReturn {
	user: User;
}
export interface UpdateUserDisplayNameArgs {
	hubId: string;
	updateDisplayNameReq: UpdateDisplayNameRequest;
}

export interface UpdateUserDisplayNameReturn {
	user: User;
}
export interface UpdateUserEmailArgs {
	hubId: string;
	updateEmail: UpdateEmailRequest;
}

export interface UpdateUserEmailReturn {
	response: Empty;
}
export interface UpsertHubUserArgs {
	hubId: string;
	displayName: string;
}

export interface UpsertHubUserReturn {
	hubUser: HubUser;
}

//
// Client
//
export class HubsAPI implements HubsAPI {
	protected hostname: string;
	protected fetch: Fetch;
	protected path = '/rpc/HubsAPI/';

	constructor(hostname: string, fetch: Fetch) {
		this.hostname = hostname;
		this.fetch = fetch;
	}

	private url(name: string): string {
		return this.hostname + this.path + name;
	}

	activateMember = (args: ActivateMemberArgs, headers?: object): Promise<ActivateMemberReturn> => {
		return this.fetch(this.url('ActivateMember'), createHTTPRequest(args, headers)).then((res) => {
			return buildResponse(res).then((_data) => {
				return {
					status: <ActivateMemberStatus>_data.status,
				};
			});
		});
	};

	checkDisplayNameUniqueness = (
		args: CheckDisplayNameUniquenessArgs,
		headers?: object
	): Promise<CheckDisplayNameUniquenessReturn> => {
		return this.fetch(
			this.url('CheckDisplayNameUniqueness'),
			createHTTPRequest(args, headers)
		).then((res) => {
			return buildResponse(res).then((_data) => {
				return {
					isUnique: <boolean>_data.isUnique,
				};
			});
		});
	};

	cloneNewsletter = (
		args: CloneNewsletterArgs,
		headers?: object
	): Promise<CloneNewsletterReturn> => {
		return this.fetch(this.url('CloneNewsletter'), createHTTPRequest(args, headers)).then((res) => {
			return buildResponse(res).then((_data) => {
				return {
					newsletter: <Newsletter>_data.newsletter,
				};
			});
		});
	};

	createCollection = (
		args: CreateCollectionArgs,
		headers?: object
	): Promise<CreateCollectionReturn> => {
		return this.fetch(this.url('CreateCollection'), createHTTPRequest(args, headers)).then(
			(res) => {
				return buildResponse(res).then((_data) => {
					return {
						collection: <Collection>_data.collection,
					};
				});
			}
		);
	};

	createHub = (args: CreateHubArgs, headers?: object): Promise<CreateHubReturn> => {
		return this.fetch(this.url('CreateHub'), createHTTPRequest(args, headers)).then((res) => {
			return buildResponse(res).then((_data) => {
				return {
					ret1: <Hub>_data.ret1,
				};
			});
		});
	};

	createOauthProvider = (
		args: CreateOauthProviderArgs,
		headers?: object
	): Promise<CreateOauthProviderReturn> => {
		return this.fetch(this.url('CreateOauthProvider'), createHTTPRequest(args, headers)).then(
			(res) => {
				return buildResponse(res).then((_data) => {
					return {
						ret1: <OauthProvider>_data.ret1,
					};
				});
			}
		);
	};

	createOrganization = (
		args: CreateOrganizationArgs,
		headers?: object
	): Promise<CreateOrganizationReturn> => {
		return this.fetch(this.url('CreateOrganization'), createHTTPRequest(args, headers)).then(
			(res) => {
				return buildResponse(res).then((_data) => {
					return {
						organization: <OrganizationWithJWT>_data.organization,
					};
				});
			}
		);
	};

	createPost = (args: CreatePostArgs, headers?: object): Promise<CreatePostReturn> => {
		return this.fetch(this.url('CreatePost'), createHTTPRequest(args, headers)).then((res) => {
			return buildResponse(res).then((_data) => {
				return {
					post: <Post>_data.post,
				};
			});
		});
	};

	deleteCollection = (
		args: DeleteCollectionArgs,
		headers?: object
	): Promise<DeleteCollectionReturn> => {
		return this.fetch(this.url('DeleteCollection'), createHTTPRequest(args, headers)).then(
			(res) => {
				return buildResponse(res).then((_data) => {
					return {};
				});
			}
		);
	};

	deleteDraftNewsletter = (
		args: DeleteDraftNewsletterArgs,
		headers?: object
	): Promise<DeleteDraftNewsletterReturn> => {
		return this.fetch(this.url('DeleteDraftNewsletter'), createHTTPRequest(args, headers)).then(
			(res) => {
				return buildResponse(res).then((_data) => {
					return {
						_: <Empty>_data._,
					};
				});
			}
		);
	};

	deleteInvite = (args: DeleteInviteArgs, headers?: object): Promise<DeleteInviteReturn> => {
		return this.fetch(this.url('DeleteInvite'), createHTTPRequest(args, headers)).then((res) => {
			return buildResponse(res).then((_data) => {
				return {
					_: <Empty>_data._,
				};
			});
		});
	};

	deleteOauthProvider = (
		args: DeleteOauthProviderArgs,
		headers?: object
	): Promise<DeleteOauthProviderReturn> => {
		return this.fetch(this.url('DeleteOauthProvider'), createHTTPRequest(args, headers)).then(
			(res) => {
				return buildResponse(res).then((_data) => {
					return {
						response: <Empty>_data.response,
					};
				});
			}
		);
	};

	deletePost = (args: DeletePostArgs, headers?: object): Promise<DeletePostReturn> => {
		return this.fetch(this.url('DeletePost'), createHTTPRequest(args, headers)).then((res) => {
			return buildResponse(res).then((_data) => {
				return {
					_: <Empty>_data._,
				};
			});
		});
	};

	embedLink = (args: EmbedLinkArgs, headers?: object): Promise<EmbedLinkReturn> => {
		return this.fetch(this.url('EmbedLink'), createHTTPRequest(args, headers)).then((res) => {
			return buildResponse(res).then((_data) => {
				return {
					asset: <Asset>_data.asset,
				};
			});
		});
	};

	featurePost = (args: FeaturePostArgs, headers?: object): Promise<FeaturePostReturn> => {
		return this.fetch(this.url('FeaturePost'), createHTTPRequest(args, headers)).then((res) => {
			return buildResponse(res).then((_data) => {
				return {
					_: <Empty>_data._,
				};
			});
		});
	};

	getCollaborators = (
		args: GetCollaboratorsArgs,
		headers?: object
	): Promise<GetCollaboratorsReturn> => {
		return this.fetch(this.url('GetCollaborators'), createHTTPRequest(args, headers)).then(
			(res) => {
				return buildResponse(res).then((_data) => {
					return {
						users: <Array<User>>_data.users,
						pages: <Pages>_data.pages,
					};
				});
			}
		);
	};

	getCollection = (args: GetCollectionArgs, headers?: object): Promise<GetCollectionReturn> => {
		return this.fetch(this.url('GetCollection'), createHTTPRequest(args, headers)).then((res) => {
			return buildResponse(res).then((_data) => {
				return {
					collection: <Collection>_data.collection,
				};
			});
		});
	};

	getFeaturedPosts = (
		args: GetFeaturedPostsArgs,
		headers?: object
	): Promise<GetFeaturedPostsReturn> => {
		return this.fetch(this.url('GetFeaturedPosts'), createHTTPRequest(args, headers)).then(
			(res) => {
				return buildResponse(res).then((_data) => {
					return {
						featuredPosts: <Array<Post>>_data.featuredPosts,
					};
				});
			}
		);
	};

	getHub = (args: GetHubArgs, headers?: object): Promise<GetHubReturn> => {
		return this.fetch(this.url('GetHub'), createHTTPRequest(args, headers)).then((res) => {
			return buildResponse(res).then((_data) => {
				return {
					hub: <Hub>_data.hub,
				};
			});
		});
	};

	getHubComments = (args: GetHubCommentsArgs, headers?: object): Promise<GetHubCommentsReturn> => {
		return this.fetch(this.url('GetHubComments'), createHTTPRequest(args, headers)).then((res) => {
			return buildResponse(res).then((_data) => {
				return {
					comments: <Array<Post>>_data.comments,
					pages: <Pages>_data.pages,
				};
			});
		});
	};

	getHubFromUrl = (args: GetHubFromUrlArgs, headers?: object): Promise<GetHubFromUrlReturn> => {
		return this.fetch(this.url('GetHubFromUrl'), createHTTPRequest(args, headers)).then((res) => {
			return buildResponse(res).then((_data) => {
				return {
					hub: <Hub>_data.hub,
				};
			});
		});
	};

	getMemberGroups = (
		args: GetMemberGroupsArgs,
		headers?: object
	): Promise<GetMemberGroupsReturn> => {
		return this.fetch(this.url('GetMemberGroups'), createHTTPRequest(args, headers)).then((res) => {
			return buildResponse(res).then((_data) => {
				return {
					memberGroups: <Array<MemberGroup>>_data.memberGroups,
				};
			});
		});
	};

	getMemberSignupData = (
		args: GetMemberSignupDataArgs,
		headers?: object
	): Promise<GetMemberSignupDataReturn> => {
		return this.fetch(this.url('GetMemberSignupData'), createHTTPRequest(args, headers)).then(
			(res) => {
				return buildResponse(res).then((_data) => {
					return {
						memberSignupData: <MemberSignupData>_data.memberSignupData,
					};
				});
			}
		);
	};

	getMemberVariablesSettings = (
		args: GetMemberVariablesSettingsArgs,
		headers?: object
	): Promise<GetMemberVariablesSettingsReturn> => {
		return this.fetch(
			this.url('GetMemberVariablesSettings'),
			createHTTPRequest(args, headers)
		).then((res) => {
			return buildResponse(res).then((_data) => {
				return {
					memberVariablesSettings: <Array<MemberVariableSettings>>_data.memberVariablesSettings,
				};
			});
		});
	};

	getMemberVariablesValues = (
		args: GetMemberVariablesValuesArgs,
		headers?: object
	): Promise<GetMemberVariablesValuesReturn> => {
		return this.fetch(this.url('GetMemberVariablesValues'), createHTTPRequest(args, headers)).then(
			(res) => {
				return buildResponse(res).then((_data) => {
					return {
						memberVariablesValue: <Array<MemberVariableValue>>_data.memberVariablesValue,
					};
				});
			}
		);
	};

	getMembers = (args: GetMembersArgs, headers?: object): Promise<GetMembersReturn> => {
		return this.fetch(this.url('GetMembers'), createHTTPRequest(args, headers)).then((res) => {
			return buildResponse(res).then((_data) => {
				return {
					users: <Array<User>>_data.users,
					pages: <Pages>_data.pages,
				};
			});
		});
	};

	getNewsletter = (args: GetNewsletterArgs, headers?: object): Promise<GetNewsletterReturn> => {
		return this.fetch(this.url('GetNewsletter'), createHTTPRequest(args, headers)).then((res) => {
			return buildResponse(res).then((_data) => {
				return {
					newsletter: <Newsletter>_data.newsletter,
				};
			});
		});
	};

	getNewsletters = (args: GetNewslettersArgs, headers?: object): Promise<GetNewslettersReturn> => {
		return this.fetch(this.url('GetNewsletters'), createHTTPRequest(args, headers)).then((res) => {
			return buildResponse(res).then((_data) => {
				return {
					newsletters: <Array<Newsletter>>_data.newsletters,
					pages: <Pages>_data.pages,
				};
			});
		});
	};

	getOwnPosts = (args: GetOwnPostsArgs, headers?: object): Promise<GetOwnPostsReturn> => {
		return this.fetch(this.url('GetOwnPosts'), createHTTPRequest(args, headers)).then((res) => {
			return buildResponse(res).then((_data) => {
				return {
					posts: <Array<Post>>_data.posts,
					pages: <Pages>_data.pages,
				};
			});
		});
	};

	getPinnedPosts = (args: GetPinnedPostsArgs, headers?: object): Promise<GetPinnedPostsReturn> => {
		return this.fetch(this.url('GetPinnedPosts'), createHTTPRequest(args, headers)).then((res) => {
			return buildResponse(res).then((_data) => {
				return {
					pinnedPosts: <Array<Post>>_data.pinnedPosts,
				};
			});
		});
	};

	getPost = (args: GetPostArgs, headers?: object): Promise<GetPostReturn> => {
		return this.fetch(this.url('GetPost'), createHTTPRequest(args, headers)).then((res) => {
			return buildResponse(res).then((_data) => {
				return {
					post: <Post>_data.post,
				};
			});
		});
	};

	getPostContributions = (
		args: GetPostContributionsArgs,
		headers?: object
	): Promise<GetPostContributionsReturn> => {
		return this.fetch(this.url('GetPostContributions'), createHTTPRequest(args, headers)).then(
			(res) => {
				return buildResponse(res).then((_data) => {
					return {
						contributions: <Array<Post>>_data.contributions,
						pages: <Pages>_data.pages,
					};
				});
			}
		);
	};

	getPosts = (args: GetPostsArgs, headers?: object): Promise<GetPostsReturn> => {
		return this.fetch(this.url('GetPosts'), createHTTPRequest(args, headers)).then((res) => {
			return buildResponse(res).then((_data) => {
				return {
					posts: <Array<Post>>_data.posts,
					pages: <Pages>_data.pages,
				};
			});
		});
	};

	getSessionHubUser = (
		args: GetSessionHubUserArgs,
		headers?: object
	): Promise<GetSessionHubUserReturn> => {
		return this.fetch(this.url('GetSessionHubUser'), createHTTPRequest(args, headers)).then(
			(res) => {
				return buildResponse(res).then((_data) => {
					return {
						user: <User>_data.user,
						expiresIn: <number>_data.expiresIn,
					};
				});
			}
		);
	};

	getSessionUser = (headers?: object): Promise<GetSessionUserReturn> => {
		return this.fetch(this.url('GetSessionUser'), createHTTPRequest({}, headers)).then((res) => {
			return buildResponse(res).then((_data) => {
				return {
					user: <User>_data.user,
				};
			});
		});
	};

	getTouchpointQuickPollLinks = (
		args: GetTouchpointQuickPollLinksArgs,
		headers?: object
	): Promise<GetTouchpointQuickPollLinksReturn> => {
		return this.fetch(
			this.url('GetTouchpointQuickPollLinks'),
			createHTTPRequest(args, headers)
		).then((res) => {
			return buildResponse(res).then((_data) => {
				return {
					hubsQuickPollLinks: <Array<QuickPoll>>_data.hubsQuickPollLinks,
				};
			});
		});
	};

	getUser = (args: GetUserArgs, headers?: object): Promise<GetUserReturn> => {
		return this.fetch(this.url('GetUser'), createHTTPRequest(args, headers)).then((res) => {
			return buildResponse(res).then((_data) => {
				return {
					user: <User>_data.user,
				};
			});
		});
	};

	getUsers = (args: GetUsersArgs, headers?: object): Promise<GetUsersReturn> => {
		return this.fetch(this.url('GetUsers'), createHTTPRequest(args, headers)).then((res) => {
			return buildResponse(res).then((_data) => {
				return {
					users: <Array<User>>_data.users,
					pages: <Pages>_data.pages,
				};
			});
		});
	};

	getVersion = (headers?: object): Promise<GetVersionReturn> => {
		return this.fetch(this.url('GetVersion'), createHTTPRequest({}, headers)).then((res) => {
			return buildResponse(res).then((_data) => {
				return {
					version: <string>_data.version,
				};
			});
		});
	};

	getWidgets = (args: GetWidgetsArgs, headers?: object): Promise<GetWidgetsReturn> => {
		return this.fetch(this.url('GetWidgets'), createHTTPRequest(args, headers)).then((res) => {
			return buildResponse(res).then((_data) => {
				return {
					onlyWidgets: <Array<Widget>>_data.onlyWidgets,
					featuredPosts: <Array<Post>>_data.featuredPosts,
					pinnedPosts: <Array<Post>>_data.pinnedPosts,
				};
			});
		});
	};

	hidePost = (args: HidePostArgs, headers?: object): Promise<HidePostReturn> => {
		return this.fetch(this.url('HidePost'), createHTTPRequest(args, headers)).then((res) => {
			return buildResponse(res).then((_data) => {
				return {
					post: <Post>_data.post,
				};
			});
		});
	};

	invalidateSessions = (
		args: InvalidateSessionsArgs,
		headers?: object
	): Promise<InvalidateSessionsReturn> => {
		return this.fetch(this.url('InvalidateSessions'), createHTTPRequest(args, headers)).then(
			(res) => {
				return buildResponse(res).then((_data) => {
					return {
						ret1: <Hub>_data.ret1,
					};
				});
			}
		);
	};

	likePost = (args: LikePostArgs, headers?: object): Promise<LikePostReturn> => {
		return this.fetch(this.url('LikePost'), createHTTPRequest(args, headers)).then((res) => {
			return buildResponse(res).then((_data) => {
				return {
					_: <Empty>_data._,
				};
			});
		});
	};

	listAddons = (args: ListAddonsArgs, headers?: object): Promise<ListAddonsReturn> => {
		return this.fetch(this.url('ListAddons'), createHTTPRequest(args, headers)).then((res) => {
			return buildResponse(res).then((_data) => {
				return {
					addons: <Array<AddonConfig>>_data.addons,
				};
			});
		});
	};

	listAddonsMap = (args: ListAddonsMapArgs, headers?: object): Promise<ListAddonsMapReturn> => {
		return this.fetch(this.url('ListAddonsMap'), createHTTPRequest(args, headers)).then((res) => {
			return buildResponse(res).then((_data) => {
				return {
					addons: <{ [key: string]: Array<AddonConfig> }>_data.addons,
				};
			});
		});
	};

	listInvites = (args: ListInvitesArgs, headers?: object): Promise<ListInvitesReturn> => {
		return this.fetch(this.url('ListInvites'), createHTTPRequest(args, headers)).then((res) => {
			return buildResponse(res).then((_data) => {
				return {
					userInvites: <Array<UserInvite>>_data.userInvites,
					pages: <Pages>_data.pages,
				};
			});
		});
	};

	listOauthProviders = (
		args: ListOauthProvidersArgs,
		headers?: object
	): Promise<ListOauthProvidersReturn> => {
		return this.fetch(this.url('ListOauthProviders'), createHTTPRequest(args, headers)).then(
			(res) => {
				return buildResponse(res).then((_data) => {
					return {
						providers: <Array<OauthProvider>>_data.providers,
					};
				});
			}
		);
	};

	login = (args: LoginArgs, headers?: object): Promise<LoginReturn> => {
		return this.fetch(this.url('Login'), createHTTPRequest(args, headers)).then((res) => {
			return buildResponse(res).then((_data) => {
				return {
					response: <LoginResponse>_data.response,
				};
			});
		});
	};

	lookupHubUser = (args: LookupHubUserArgs, headers?: object): Promise<LookupHubUserReturn> => {
		return this.fetch(this.url('LookupHubUser'), createHTTPRequest(args, headers)).then((res) => {
			return buildResponse(res).then((_data) => {
				return {
					lookupHubUser: <LookupHubUser>_data.lookupHubUser,
				};
			});
		});
	};

	memberSignup = (args: MemberSignupArgs, headers?: object): Promise<MemberSignupReturn> => {
		return this.fetch(this.url('MemberSignup'), createHTTPRequest(args, headers)).then((res) => {
			return buildResponse(res).then((_data) => {
				return {
					memberSignupPage: <MemberSignUpPage>_data.memberSignupPage,
				};
			});
		});
	};

	orgAdminGetActiveHubs = (
		args: OrgAdminGetActiveHubsArgs,
		headers?: object
	): Promise<OrgAdminGetActiveHubsReturn> => {
		return this.fetch(this.url('OrgAdminGetActiveHubs'), createHTTPRequest(args, headers)).then(
			(res) => {
				return buildResponse(res).then((_data) => {
					return {
						hubs: <Array<Hub>>_data.hubs,
						pages: <Pages>_data.pages,
					};
				});
			}
		);
	};

	orgAdminGetHubs = (
		args: OrgAdminGetHubsArgs,
		headers?: object
	): Promise<OrgAdminGetHubsReturn> => {
		return this.fetch(this.url('OrgAdminGetHubs'), createHTTPRequest(args, headers)).then((res) => {
			return buildResponse(res).then((_data) => {
				return {
					hubs: <Array<Hub>>_data.hubs,
					pages: <Pages>_data.pages,
				};
			});
		});
	};

	orgAdminGetOrganizations = (
		args: OrgAdminGetOrganizationsArgs,
		headers?: object
	): Promise<OrgAdminGetOrganizationsReturn> => {
		return this.fetch(this.url('OrgAdminGetOrganizations'), createHTTPRequest(args, headers)).then(
			(res) => {
				return buildResponse(res).then((_data) => {
					return {
						orgs: <Array<Organization>>_data.orgs,
						pages: <Pages>_data.pages,
					};
				});
			}
		);
	};

	pinPost = (args: PinPostArgs, headers?: object): Promise<PinPostReturn> => {
		return this.fetch(this.url('PinPost'), createHTTPRequest(args, headers)).then((res) => {
			return buildResponse(res).then((_data) => {
				return {
					_: <Empty>_data._,
				};
			});
		});
	};

	recordCCPA = (args: RecordCCPAArgs, headers?: object): Promise<RecordCCPAReturn> => {
		return this.fetch(this.url('RecordCCPA'), createHTTPRequest(args, headers)).then((res) => {
			return buildResponse(res).then((_data) => {
				return {
					response: <Empty>_data.response,
				};
			});
		});
	};

	refreshSession = (args: RefreshSessionArgs, headers?: object): Promise<RefreshSessionReturn> => {
		return this.fetch(this.url('RefreshSession'), createHTTPRequest(args, headers)).then((res) => {
			return buildResponse(res).then((_data) => {
				return {
					expiresIn: <number>_data.expiresIn,
				};
			});
		});
	};

	reorderCollection = (
		args: ReorderCollectionArgs,
		headers?: object
	): Promise<ReorderCollectionReturn> => {
		return this.fetch(this.url('ReorderCollection'), createHTTPRequest(args, headers)).then(
			(res) => {
				return buildResponse(res).then((_data) => {
					return {
						collections: <Array<Collection>>_data.collections,
					};
				});
			}
		);
	};

	searchPosts = (args: SearchPostsArgs, headers?: object): Promise<SearchPostsReturn> => {
		return this.fetch(this.url('SearchPosts'), createHTTPRequest(args, headers)).then((res) => {
			return buildResponse(res).then((_data) => {
				return {
					posts: <Array<Post>>_data.posts,
					pages: <Pages>_data.pages,
				};
			});
		});
	};

	setMemberPassword = (
		args: SetMemberPasswordArgs,
		headers?: object
	): Promise<SetMemberPasswordReturn> => {
		return this.fetch(this.url('SetMemberPassword'), createHTTPRequest(args, headers)).then(
			(res) => {
				return buildResponse(res).then((_data) => {
					return {
						response: <Empty>_data.response,
					};
				});
			}
		);
	};

	showPost = (args: ShowPostArgs, headers?: object): Promise<ShowPostReturn> => {
		return this.fetch(this.url('ShowPost'), createHTTPRequest(args, headers)).then((res) => {
			return buildResponse(res).then((_data) => {
				return {
					post: <Post>_data.post,
				};
			});
		});
	};

	unfeaturePost = (args: UnfeaturePostArgs, headers?: object): Promise<UnfeaturePostReturn> => {
		return this.fetch(this.url('UnfeaturePost'), createHTTPRequest(args, headers)).then((res) => {
			return buildResponse(res).then((_data) => {
				return {
					_: <Empty>_data._,
				};
			});
		});
	};

	unlikePost = (args: UnlikePostArgs, headers?: object): Promise<UnlikePostReturn> => {
		return this.fetch(this.url('UnlikePost'), createHTTPRequest(args, headers)).then((res) => {
			return buildResponse(res).then((_data) => {
				return {
					_: <Empty>_data._,
				};
			});
		});
	};

	unpinPost = (args: UnpinPostArgs, headers?: object): Promise<UnpinPostReturn> => {
		return this.fetch(this.url('UnpinPost'), createHTTPRequest(args, headers)).then((res) => {
			return buildResponse(res).then((_data) => {
				return {
					_: <Empty>_data._,
				};
			});
		});
	};

	updateCollection = (
		args: UpdateCollectionArgs,
		headers?: object
	): Promise<UpdateCollectionReturn> => {
		return this.fetch(this.url('UpdateCollection'), createHTTPRequest(args, headers)).then(
			(res) => {
				return buildResponse(res).then((_data) => {
					return {
						collection: <Collection>_data.collection,
					};
				});
			}
		);
	};

	updateHub = (args: UpdateHubArgs, headers?: object): Promise<UpdateHubReturn> => {
		return this.fetch(this.url('UpdateHub'), createHTTPRequest(args, headers)).then((res) => {
			return buildResponse(res).then((_data) => {
				return {
					hub: <Hub>_data.hub,
				};
			});
		});
	};

	updateMemberVariables = (
		args: UpdateMemberVariablesArgs,
		headers?: object
	): Promise<UpdateMemberVariablesReturn> => {
		return this.fetch(this.url('UpdateMemberVariables'), createHTTPRequest(args, headers)).then(
			(res) => {
				return buildResponse(res).then((_data) => {
					return {
						empty: <Empty>_data.empty,
					};
				});
			}
		);
	};

	updateOauthProvider = (
		args: UpdateOauthProviderArgs,
		headers?: object
	): Promise<UpdateOauthProviderReturn> => {
		return this.fetch(this.url('UpdateOauthProvider'), createHTTPRequest(args, headers)).then(
			(res) => {
				return buildResponse(res).then((_data) => {
					return {
						ret1: <OauthProvider>_data.ret1,
					};
				});
			}
		);
	};

	updatePost = (args: UpdatePostArgs, headers?: object): Promise<UpdatePostReturn> => {
		return this.fetch(this.url('UpdatePost'), createHTTPRequest(args, headers)).then((res) => {
			return buildResponse(res).then((_data) => {
				return {
					response: <Post>_data.response,
				};
			});
		});
	};

	updateUserAvatar = (
		args: UpdateUserAvatarArgs,
		headers?: object
	): Promise<UpdateUserAvatarReturn> => {
		return this.fetch(this.url('UpdateUserAvatar'), createHTTPRequest(args, headers)).then(
			(res) => {
				return buildResponse(res).then((_data) => {
					return {
						user: <User>_data.user,
					};
				});
			}
		);
	};

	updateUserDisplayName = (
		args: UpdateUserDisplayNameArgs,
		headers?: object
	): Promise<UpdateUserDisplayNameReturn> => {
		return this.fetch(this.url('UpdateUserDisplayName'), createHTTPRequest(args, headers)).then(
			(res) => {
				return buildResponse(res).then((_data) => {
					return {
						user: <User>_data.user,
					};
				});
			}
		);
	};

	updateUserEmail = (
		args: UpdateUserEmailArgs,
		headers?: object
	): Promise<UpdateUserEmailReturn> => {
		return this.fetch(this.url('UpdateUserEmail'), createHTTPRequest(args, headers)).then((res) => {
			return buildResponse(res).then((_data) => {
				return {
					response: <Empty>_data.response,
				};
			});
		});
	};

	upsertHubUser = (args: UpsertHubUserArgs, headers?: object): Promise<UpsertHubUserReturn> => {
		return this.fetch(this.url('UpsertHubUser'), createHTTPRequest(args, headers)).then((res) => {
			return buildResponse(res).then((_data) => {
				return {
					hubUser: <HubUser>_data.hubUser,
				};
			});
		});
	};
}

export interface WebRPCError extends Error {
	code: string;
	msg: string;
	status: number;
}

const createHTTPRequest = (body: object = {}, headers: object = {}): object => {
	return {
		method: 'POST',
		headers: { ...headers, 'Content-Type': 'application/json' },
		body: JSON.stringify(body || {}),
	};
};

const buildResponse = (res: Response): Promise<any> => {
	return res.text().then((text) => {
		let data;
		try {
			data = JSON.parse(text);
		} catch (err) {
			throw {
				code: 'unknown',
				msg: `expecting JSON, got: ${text}`,
				status: res.status,
			} as WebRPCError;
		}
		if (!res.ok) {
			throw data; // webrpc error response
		}
		return data;
	});
};

export type Fetch = (input: RequestInfo, init?: RequestInit) => Promise<Response>;
